module.exports = "/images/icon_fordvehicle_yellow.png?4b05f2f4d0e31f591fc55dec5a6e01e2";